<template>
  <div class="carousel-tile-container">
    <component
      :is="tileComponentTag"
      :class="['carousel-tile', { hover: showActions }]"
      @click="tileClicked"
    >
      <div class="name">
        <span class="name-text">
          {{ name }}
        </span>
      </div>
      <div
        :style="{ background: color }"
        class="count"
      >
        <span
          v-if="badge"
          class="badge"
        >{{ badge }}</span>
        <template v-else>
          {{ count }} {{ tileDisplayName }}
        </template>
        <button v-if="locked">
          <icon
            name="lock"
            variant="white"
          />
        </button>
      </div>
      <div
        v-if="showActions"
        class="actions"
      >
        <button
          v-for="(action, index) in localActions"
          :key="index"
          @click="actionClicked(action)"
        >
          {{ action }}
        </button>
      </div>
    </component>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  components: { Icon },
  props: {
    actions: {
      type: Array,
      default: () => [],
    },
    color: {
      type: String,
    },
    count: {
      type: Number,
    },
    tileDisplayName: {
      type: String,
    },
    // Red label shown in place of the count
    badge: {
      type: String,
      default: null,
    },
    locked: {
      type: Boolean,
      default: false,
    },
    properties: {
      type: Object,
    },
  },
  emits: ['actionClicked', 'tileClicked'],
  data() {
    return {
      tileTransitioning: false,
      localActions: [],
    };
  },
  computed: {
    showActions() {
      return this.actions.length > 0 && !this.locked;
    },
    tileComponentTag() {
      return this.showActions ? 'div' : 'button';
    },
    name() {
      let p = this.properties;
      return p.name || p.title || p.displayTitle || '';
    },
  },
  mounted() {
    this.$watch('actions', (newActions) => {
      if (newActions && !this.tileTransitioning) {
        this.localActions = newActions;
      }
    }, { immediate: true });
  },
  methods: {
    actionClicked(action) {
      this.tileTransitioning = true;
      this.$emit('actionClicked', action);
    },
    tileClicked() {
      if (!this.showActions) {
        this.$emit('tileClicked');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.carousel-tile-container {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  display: inline-block;
  height: rem-calc(100);
  margin: rem-calc(10) rem-calc(8) rem-calc(10) 0;
  width: rem-calc(120);
  overflow: hidden;
  vertical-align: top;

  .carousel-tile {
    background: white;
    height: 100%;
    padding: 0;
    text-align: left;
    width: 100%;

    &.hover:hover {
      .actions {
        transform: translateY(-100px);
      }
    }

    .actions {
      background: #ffffff;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      font-size: rem-calc(12);
      transition: all .25s ease-in-out;

      button {
        background: transparent;
        border-bottom: 1px solid #f4f4f4;
        display: flex;
        flex: 1;
        justify-content: center;
        align-items: center;
        font-weight: $semi-bold;

        &:hover {
          background: #f4f4f4;
        }
      }
    }
  }

  .name {
    display: flex;
    align-items: flex-end;
    box-sizing: border-box;
    color: #404a54;
    font-size: rem-calc(12);
    font-weight: $semi-bold;
    height: rem-calc(70);
    padding: rem-calc(10);
    white-space: normal;
  }

  .name-text {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;

    display: flex;

    /* Optional: Add standard line-clamp if supported */
    line-clamp: 4;
  }

  .badge {
    background: #dc3416;
    border-radius: rem-calc(4);
    color: white;
    padding: rem-calc(2) rem-calc(6);
  }

  .count {
    box-sizing: border-box;
    color: white;
    font-size: rem-calc(8);
    font-weight: $bold;
    height: rem-calc(30);
    letter-spacing: 0.8px;
    padding: rem-calc(10);

    button {
      background: #374554;
      border-radius: 100%;
      padding: rem-calc(3) rem-calc(4) rem-calc(4) rem-calc(4);
      float: right;
      margin-top: rem-calc(-18);
      margin-right: rem-calc(-2);

      img {
        height: rem-calc(9);
        width: rem-calc(9);
        display: block;
      }
    }
  }
}
</style>
